import React from 'react';
import { User } from 'types';
import styles from '../EditUserSettings/EditUserSettings.module.scss';
import { Button } from '../../../../../../components/ui/button';
import { Grid } from '@mui/material';
import EmployeeNoteEdit from './EmployeeNoteEdit';

interface EmployeeNotesScreenProps {
	user: User;
	onBack: () => void;
}

const EmployeeNotesScreen: React.FC<EmployeeNotesScreenProps> = ({ user, onBack }) => {
	return (
		<div className={styles.editUserSetting}>
			<Grid container direction="column" spacing={2} pl={2}>
				<Grid container direction="row" justifyContent="space-between">
					<Grid>
						<Button className={styles.backButton} onClick={onBack}>
							Back
						</Button>
					</Grid>
				</Grid>
				<Grid container direction="row" justifyContent="flex-start" alignItems="center">
					<h2 className={styles.formTitle}>Employee Notes - {user.firstName} {user.lastName}</h2>
				</Grid>
			</Grid>

			<div style={{ padding: '16px' }}>
				<EmployeeNoteEdit user={user} />
			</div>
		</div>
	);
};

export default EmployeeNotesScreen;
